<template>
    <div>

        <config-main-title>
            Terceiros
        </config-main-title>

        <template v-if="edicao_info">
            <cadastro-terceiro-infos 
                ref="cad_info"
                :terceiro="edicao_info" 
                @fechar="edicao_info = null" />
        </template>

        <template v-else>

            <div v-if="!em_edicao">

                <div class="row mb-3">
                    <div class="col col-12 col-md-9 d-flex flex-column">
                        <az-input icon="fas fa-search" v-model="search" />
                    </div>
                    <div class="col col-12 col-md-3 d-flex flex-column">
                        <div class="btn-group mb-1" role="group" aria-label="Basic example">
                            <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'"
                            @click="viewMode = 'A'">
                                Ativos
                            </button>
                            <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'"
                            @click="viewMode = 'T'">
                                Todos
                            </button>
                        </div>
                    </div>
                </div>

            </div>

            <div v-if="( !lista || !lista.length )">
                <az-empty-state
                    :msg="'Nenhum terceiro identificado.'"
                    icon="fas fa-search" />
            </div>

            <div v-if="!em_edicao && lista && lista.length">

                <div class="list-group mb-3 az-anime-surgir mb-3">
                    <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                        <span>
                            <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                                {{ dado.search }}
                            </a>
                            <span class="badge badge-secondary" v-if="dado.st_sigla">
                                {{ dado.st_sigla }}
                            </span>
                            <span v-if="dado.fl_recorrente" class="text-muted"
                                data-toggle="tooltip" data-placement="top" title="Recorrente">
                                <i class="fas fa-sync"></i>
                            </span>
                        </span>
                        <span>
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input"
                                    :id="'ativo-' + id"
                                    v-model="dado.fl_ativo"
                                    @change="toggle(dado)">
                                <label class="custom-control-label" :for="'ativo-' + id"></label>
                            </div>
                            <div v-else>
                                <span class="badge badge-secondary mr-3" title="Filtros." v-if="dado.filtros && dado.filtros.length">
                                    <i class="fa-solid fa-filter"></i>
                                    {{ dado.filtros.length }}
                                </span>

                                <span class="badge badge-secondary mr-3" title="Itens mapeados ativos.">
                                    {{ dado.procedimento_terceiros_count }}
                                </span>

                                <button type="button" class="btn btn-outline-primary btn-sm mr-1" title="Configurar Servidor de Impressão" v-if="1==0 && dado.st_classe == 'terceiroMidSmart'" @click="config_servimp()">
                                    <i class="fa-solid fa-server"></i>
                                </button>

                                <button type="button" class="btn btn-outline-primary btn-sm mr-1" title="Informações Complementares" v-if="dado.st_classe == 'terceiroFleury'" @click="editar_info(dado)">
                                    <i class="fa-solid fa-circle-question"></i>
                                </button>

                                <button type="button" class="btn btn-outline-primary btn-sm" @click="carregar_de_para(dado)">
                                    <i class="fa-solid fa-link"></i>
                                </button>
                            </div>
                        </span>
                    </li>
                </div>

            </div>

            <!-- Formulário de edição -->
            <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-xl modal-dialog-scrollable" 
                    :class="( item && ( item.operadoras && item.js_credenciais && ( item.js_credenciais.enviar_operadoras == 'S' || item.js_credenciais.enviar_operadoras == 'P' ) ) ) ? 'modal-dialog2' : ''" role="document">
                    <div class="modal-content" v-if="item">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">
                                {{ item.st_terceiro }}
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body" v-if="item">
                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Sigla"
                                        :validate="validate"
                                        v-model="item.st_sigla" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Status para Recebimento de Resultado"
                                        type="select"
                                        optionsMode="aql"
                                        service="status_laudos.index"
                                        optionsData="id_status_laudo"
                                        :validate="validate"
                                        v-model="item.id_status_laudo" />
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        type="checkbox-group"
                                        label="Produção"
                                        v-model="item.fl_producao" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Etiqueta EPL"
                                        type="checkbox-group"
                                        v-model="item.fl_etiqueta_epl" />
                                </div>
                            </div>
                            
                            <template v-if="item.js_credenciais">
                                <div class="row" v-for="(valor, campo, icx) in item.js_credenciais" :key="icx">
                                    <div class="col col-12">
                                        <az-input
                                            :label="campo"
                                            :type="campo != 'etiqueta' ? 'text' : 'textarea'"
                                            :validate="validate"
                                            required
                                            v-model="item.js_credenciais[campo]" />
                                    </div>
                                </div>

                                <template v-if="item.st_classe == 'terceiroAlvaro' || item.st_classe == 'terceiroDB' || item.st_classe == 'terceiroPardini'">

                                    <button type="button" class="btn btn-primary btn-sm mt-3" @click="incluir_unidade(item)">
                                        <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                                        Unidade
                                    </button>

                                    <table class="table mt-3">
                                        <template v-for="(unidade, iux) in item.unidades">
                                            <tr :key="iux" v-show="!unidade.excluido">
                                                <td>
                                                    <az-input
                                                        sizing="sm"
                                                        label="Unidade"
                                                        type="select"
                                                        :optionsList="$util.unidades_com_tags(false, false)"
                                                        optionsData="id_unidade_operacao"
                                                        placeholder="Selecione..."
                                                        :validate="validate"
                                                        required
                                                        v-model="unidade.id_unidade_operacao">
                                                        <template v-slot:button-pre>
                                                            <div class="input-group-prepend">
                                                                <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="unidade.excluido = true">
                                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                                </button>
                                                            </div>
                                                        </template>
                                                    </az-input>
                                                </td>
                                                <td v-for="(valor, campo, icx) in unidade.js_credenciais" :key="icx">
                                                    <az-input
                                                        sizing="sm"
                                                        :label="campo"
                                                        :type="campo != 'etiqueta' ? 'text' : 'textarea'"
                                                        :validate="validate"
                                                        required
                                                        v-model="unidade.js_credenciais[campo]" />
                                                </td>
                                            </tr>
                                        </template>
                                    </table>

                                </template>
                            </template>

                            <template v-if="item.fl_etiqueta_epl">
                                <div class="row mt-3">
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            label="Largura da página"
                                            type="number"
                                            :validate="validate"
                                            v-model="item.in_papel_largura" />
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            label="Altura da página"
                                            type="number"
                                            :validate="validate"
                                            v-model="item.in_papel_altura" />
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            label="Fator Redução eixo Y"
                                            type="money"
                                            :validate="validate"
                                            v-model="item.dc_fator_y" />
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            label="Fator Redução Codigo de Barras"
                                            type="money"
                                            :validate="validate"
                                            v-model="item.dc_fator_codbar" />
                                    </div>
                                </div>
                            </template>

                            <template v-if="item.operadoras && item.js_credenciais && ( item.js_credenciais.enviar_operadoras == 'S' || item.js_credenciais.enviar_operadoras == 'P' )">

                                <az-sub-title class="mt-2" title="Operadoras" />

                                <div class="form-row">
                                    <div class="col col-12 col-md-1">
                                        <az-input 
                                            sizing="sm" 
                                            placeholder="Convênio..."
                                            v-model="novoCodigoConvenio" />
                                    </div>

                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            name="operadora-terceiro"
                                            icon="fas fa-plus"
                                            type="select"
                                            optionsMode="aql"
                                            service="operadoras.index"
                                            v-model="novaOperadora"
                                            @input="adicionarOperadora ()">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                    <az-input
                                                        :mb="false"
                                                        sizing="sm"
                                                        type="button-group"
                                                        :optionsList="[
                                                            { id: 'add', search: 'fa fa-plus', icon: true }, 
                                                            { id: 'copy', search: 'fas fa-copy', icon: true }, 
                                                        ]" 
                                                        optionsData="id" 
                                                        v-model="acao_operadora" />
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>

                                    <div class="col col-12 col-md-3" v-if="novaOperadora && ( novaOperadora.id_operadora == 1 )">
                                        <az-input
                                            sizing="sm"
                                            name="operadora-plano-terceiro"
                                            optionsName="operadora-plano-terceiro"
                                            type="autocomplete"
                                            optionsMode="aql"
                                            placeholder="Particular..."
                                            :optionsParm="{ cadastro_unidade: true }"
                                            :optionsSync="false"
                                            service="planos.index"
                                            v-model="novoPlano"
                                            @input="adicionarOperadora ()" />
                                    </div>

                                    <div class="col col-12 col-md-3" v-else-if="novaOperadora && ( item.js_credenciais.enviar_operadoras == 'P' )">
                                        <az-input
                                            sizing="sm"
                                            name="operadora-plano-terceiro-oper"
                                            optionsName="operadora-plano-terceiro"
                                            type="autocomplete"
                                            optionsMode="aql"
                                            placeholder="Plano..."
                                            :optionsParm="{ atendimento: true, id_operadora: novaOperadora.id_operadora }"
                                            optionsSync2="false"
                                            service="planos.index"
                                            v-model="novoPlano"
                                            @input="adicionarOperadora ()" />
                                    </div>

                                    <div class="col col-12" :class="( novaOperadora && ( novaOperadora.id_operadora == 1 || item.js_credenciais.enviar_operadoras == 'P' ) ) ? 'col-md-4' : 'col-md-7'">
                                        <az-input
                                            sizing="sm"
                                            icon="fa fa-search fa-fw"
                                            placeholder="Pesquisar..."
                                            v-model="operadora_search">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                    <span class="input-group-text" id="basic-addon2">
                                                        {{ operadora_filtro_qt }}
                                                    </span>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                </div>

                                <template v-for="(po, ipo) in lista_operadoras">
                                    <div class="form-row" v-show="!po.excluido" :key="'OPER' + ipo">
                                        <div class="col col-12 col-md-5">
                                            <az-input 
                                                :label="ipo ? '' : 'Operadora'"
                                                sizing="sm"
                                                :edicao="false"
                                                v-if="( po.id_operadora == 1 || item.js_credenciais.enviar_operadoras == 'P' ) && po.id_plano"
                                                v-model="po.plano.search">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend">
                                                        <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="po.excluido = true">
                                                            <i class="fa fa-minus" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append">
                                                        <button class="btn btn-outline-secondary" type="button" id="button-addon1" @click="operadora_search = po.plano.search">
                                                            <i class="fa fa-filter" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>

                                            <az-input 
                                                :label="ipo ? '' : 'Operadora'"
                                                sizing="sm"
                                                :edicao="false"
                                                v-else
                                                v-model="po.operadora.search">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend">
                                                        <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="po.excluido = true">
                                                            <i class="fa fa-minus" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append">
                                                        <button class="btn btn-outline-secondary" type="button" id="button-addon1" @click="operadora_search ? operadora_search = '' : operadora_search = po.operadora.search">
                                                            <i class="fa fa-filter" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>

                                        <div class="col col-12 col-md-2">
                                            <template v-if="!po.edicao">
                                                <az-input 
                                                    v-if="po.unidade_operacao"
                                                    :label="ipo ? '' : 'Unidade'"
                                                    sizing="sm" 
                                                    :validate="validate"
                                                    :edicao="false"
                                                    v-model="po.unidade_operacao.st_nome">
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append">
                                                            <button type="button" class="btn btn-outline-primary" @click="po.edicao = !po.edicao">
                                                                <i class="fas fa-edit"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>

                                                <az-input 
                                                    v-else
                                                    :label="ipo ? '' : 'Unidade'"
                                                    sizing="sm" 
                                                    :validate="validate"
                                                    :edicao="false"
                                                    v-model="po.id_unidade_operacao">
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append">
                                                            <button type="button" class="btn btn-outline-primary" @click="po.edicao = !po.edicao">
                                                                <i class="fas fa-edit"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </template>

                                            <az-input 
                                                v-else
                                                :label="ipo ? '' : 'Unidade'"
                                                sizing="sm" 
                                                type="select"
                                                :optionsList="$util.unidades_com_tags(false, false)"
                                                optionsData="id_unidade_operacao"
                                                placeholder="Todas..."
                                                :validate="validate"
                                                v-model="po.id_unidade_operacao" />
                                        </div>

                                        <div class="col col-12 col-md-1">
                                            <az-input 
                                                :label="ipo ? '' : 'Convênio'"
                                                sizing="sm" 
                                                placeholder="Código..."
                                                required
                                                :validate="validate"
                                                v-model="po.st_codigo_operadora" />
                                        </div>

                                        <div class="col col-12 col-md-3">
                                            <az-input 
                                                :label="ipo ? '' : 'Código Setor ou API Token'"
                                                sizing="sm" 
                                                placeholder="Padrão..."
                                                :validate="validate"
                                                v-model="po.st_codigo_setor">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append">
                                                        <button class="btn btn-outline-secondary" type="button" id="button-addon1" @click="operadora_search ? operadora_search = '' : operadora_search = po.st_codigo_setor">
                                                            <i class="fa fa-filter" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>

                                        <div class="col col-12 col-md-1">
                                            <az-input 
                                                :label="ipo ? '' : 'Enviar Valor'"
                                                sizing="sm" 
                                                type="checkbox"
                                                v-model="po.fl_enviar_valor" />
                                        </div>
                                    </div>
                                </template>

                            </template>

                            <!-- Filtros -->

                            <filtro-model class="my-3" 
                                v-model="item.filtros" 
                                :validate="validate" 
                                :opcoes="lista_opcoes_filtro" />

                            <br><br><br><br><br>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary" title="Importação do De-Para" v-if="item && item.id_terceiro" @click="importar()">
                                <i class="fas fa-upload"></i>
                            </button>
                            <az-audit-log-button model="terceiro" :id="item.id_terceiro" />
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                            <az-submit @click="atualizar ()">Atualizar</az-submit>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modal Link De-Para -->
            <div class="modal fade" id="linkDeParaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
                <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Carregar De-Para</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <az-empty-state v-if="!lista_de_para || !lista_de_para.data || !lista_de_para.data.length" :msg="'Nenhum item identificado.'" />

                            <div v-else>
                                <div class="small text-muted mb-2">
                                    {{ lista_de_para.to }} / {{ lista_de_para.total }}
                                </div>

                                <table class="table table-sm table-striped">
                                    <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th>Procedimento</th>
                                            <th>Código</th>
                                            <th>Materiais</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, idx) in lista_de_para.data" :key="idx">
                                            <td>{{ item.id_procedimento }}</td>
                                            <td>{{ item.st_procedimento }}</td>
                                            <td>{{ item.st_id_externo }}</td>
                                            <td>
                                                <div v-for="(amostra, iax) in item.amostras" :key="iax">
                                                    {{ amostra.amostra_material.st_codigo }}
                                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                    {{ amostra.search }}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <pre class="mt-3" v-if="false">{{ lista_de_para }}</pre>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                            <az-submit @click="salvar_de_para()">Gerar</az-submit>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Configuração do Servidor de Impressão -->
            <div class="modal fade" id="configServImpModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Configurar Servidor de Impressão</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="alert alert-info">Configuração do arquivo .env para o servidor de impressão de etiqueta.</div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="button" class="btn btn-primary">Save</button>
                        </div>
                    </div>
                </div>
            </div>

            <importacao 
                ref="import" 
                service="terceiros" 
                :hide="true" 
                :titulo="import_titulo"
                :parms="{ id_terceiro: id_terceiro }" 
                @refresh="load()" />

        </template>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import Importacao from '../shared/Importacao.vue';
import FiltroModel from '../shared/FiltroModel.vue';
import CadastroTerceiroInfos from './CadastroTerceiroInfos.vue';


export default {
    data () {
        return {
            dados: null,
            em_edicao: false,
            item: null,
            validate: false,
            search: "",
            viewMode: "A",
            title: "",
            short_title: "",
            service: "",
            novaOperadora: "", 
            novoPlano: "",
            operadora_search: "", 
            novoCodigoConvenio: "", 
            acao_operadora: "add", 
            lista_de_para: null, 
            id_terceiro: null, 
            import_titulo: "",
            edicao_info: null, 
        }
    },

    props: ['cadastro'],

    components: {
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        AzSubTitle,
        Importacao,
        FiltroModel, 
        CadastroTerceiroInfos
    },

    computed: {
        lista_opcoes_filtro: function () {
            return [
                {id:'App\\azure\\unidadeOperacao', search:'Unidade', service: 'unidade_operacaos.index'},
            ];
        },

        lista_filtros: function () {

            if ( !this.item )
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: {
            get() {
                let pesquisar = this.search.trim();
                let parts = pesquisar.replace(' ','.*');
                let match = parts;
                let reg = new RegExp(match, 'i');

                return this.dados && this.dados.length ?
                    this.dados.filter (item => {
                        return ( this.viewMode == 'T' || item.fl_ativo ) &&
                            ( !this.search || reg.test(JSON.stringify(item)) );
                    }) : null;
            },
        },

        lista_operadoras: function () { 
            if ( !this.item || !this.item.operadoras )
                return [];

            if ( !this.operadora_search ) 
                return this.item.operadoras;

            const reg = this.$util.getregex(this.operadora_search);

            return this.item.operadoras.filter (item => {
                return ( !item.excluido 
                    && ( !this.operadora_search || !item.id_terceiro_operadora || reg.test(JSON.stringify(item)) ) );
            });

        },

        operadora_filtro_qt: function () { 
            if ( !this.item )
                return "";

            return this.lista_operadoras.filter(item => !item.excluido).length 
                + ' / '
                + this.item.operadoras.filter(item => !item.excluido).length 
        }

    },

    methods: {
        editar_info (item) { 
            this.edicao_info = _.cloneDeep(item);

            this.$nextTick(() => {
                this.$refs.cad_info.load(); 
            });
        },
        config_servimp () { 
            $('#configServImpModal').modal('show');
        },

        importar() { 
            $('.modal').modal('hide');

            this.id_terceiro = this.item.id_terceiro;
            this.import_titulo = 'de-para ' + this.item.st_terceiro;
            this.$refs.import.iniciar_importacao();
        },

        salvar_de_para () { 
            this.$util.atualizar (this, { 
                service: 'terceiros',
                func: 'salvar_de_para',
                dados: { 
                    lista: this.lista_de_para.data,
                    id_terceiro: this.item.id_terceiro,
                }, 
                modal: 'linkDeParaModal',
                reload: true, 
            });
        },

        carregar_de_para (item) { 
            this.lista_de_para = null; 
            this.item = _.cloneDeep(item);

            $('#linkDeParaModal').modal('show');

            this.$util.load(this, { 
                service: 'terceiros',
                func: 'carregar_de_para_auto',
                parms: { 
                    id_terceiro: item.id_terceiro, 
                },
                loadTo: res => { 
                    this.lista_de_para = res;
                }
            });
        },

        incluir_unidade (item) { 

            item.unidades.push({
                id_terceiro_unidade_operacao: null, 
                id_terceiro: item.id_terceiro,
                id_unidade_operacao: "", 
                fl_ativo: true, 
                js_credenciais: _.cloneDeep(item.js_credenciais), 
                excluido: false, 
            });

        },

        adicionarOperadora () { 

            if ( this.novaOperadora ) { 

                if ( ( this.novaOperadora.id_operadora == 1 || this.item.js_credenciais.enviar_operadoras == 'P' ) && !this.novoPlano )
                    return;

                if ( this.acao_operadora == 'copy' ) { 

                    let lista = this.lista_operadoras.filter(item => item.id_terceiro_operadora);

                    if ( !lista.length ) { 
                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: 'Selecione as operadoras de origem para realizar a cópia.', 
                            life: 3000
                        });

                        return;
                    }

                    let teste = _.uniqBy(lista, item => { 
                        return item.id_operadora + '|' + item.id_plano;
                    });

                    if ( teste.length != 1 ) { 

                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: 'Só pode ter uma operadora selecionada para realizar a cópia.', 
                            life: 3000
                        });

                        return;

                    }

                    lista.forEach(item => {
                        let nova = _.cloneDeep(item);

                        nova.id_terceiro_operadora = null;
                        nova.id_operadora = this.novaOperadora.id_operadora;
                        nova.id_plano = ( this.novoPlano && ( this.novaOperadora.id_operadora == 1 || this.item.js_credenciais.enviar_operadoras == 'P' ) ) ? this.novoPlano.id_plano : null;
                        nova.st_codigo_operadora = this.novoCodigoConvenio;
                        nova.operadora = this.novaOperadora;
                        nova.plano = this.novoPlano;
                        nova.edicao = true;

                        this.item.operadoras.push(nova);
                    });

                    this.novaOperadora =  null;
                    this.novoPlano =  null;

                    this.$nextTick (() => { 
                        this.novaOperadora =  "";
                        this.novoPlano =  "";
                    });

                    return;

                }

                this.item.operadoras.push({
                    id_terceiro_operadora: null, 
                    id_terceiro: this.item.id_terceiro,
                    id_operadora: this.novaOperadora.id_operadora,
                    id_plano: ( this.novoPlano && ( this.novaOperadora.id_operadora == 1 || this.item.js_credenciais.enviar_operadoras == 'P' ) ) ? this.novoPlano.id_plano : null, 
                    id_unidade_operacao: "", 
                    st_codigo_operadora: this.novoCodigoConvenio,
                    st_codigo_setor: "", 
                    fl_enviar_valor: this.novoCodigoConvenio ? true : false, 
                    operadora: this.novaOperadora,
                    plano: this.novoPlano, 
                    excluido: false, 
                    edicao: true, 
                });

                this.novaOperadora =  null;
                this.novoPlano =  null;

                this.$nextTick (() => { 
                    this.novaOperadora =  "";
                    this.novoPlano =  "";
                });

            }

        },

        load () {
            this.$util.load(this, {
                service:'terceiros',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }
            });
        },
        editar (item) {
            this.novoCodigoConvenio = ""; 
            this.operadora_search = "";
            this.validate = false;
            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },
        atualizar () {
            this.$util.atualizar(this, {
                service: 'terceiros',
                dados: this.item,
                reload: true,
                modal: 'edicaoModal',
            });
        },

        fechar () {
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) {

            this.$util.toggle(this, {
                service: 'terceiros',
                dados: item,
            });

        },
    },

    mounted () {
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Terceiros", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () {
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>

<style scoped>
.modal-dialog2 {
  width: 98% !important;
  min-height: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}
</style>
